import React, { useState, useEffect } from "react";
import Select from "react-select";
import { Controller, useForm } from "react-hook-form";
import PropTypes from "prop-types";
const MonthOption = ({ selectedMonth, monthSelectHandler }) => {
  const [optionData, setOptionData] = useState([
    {
      id: "01",
      label: "January",
      value: "01",
    },
    {
      id: "02",
      label: "Feburary",
      value: "02",
    },
    {
      id: "03",
      label: "March",
      value: "03",
    },
    {
      id: "04",
      label: "April",
      value: "04",
    },
    {
      id: "05",
      label: "May",
      value: "05",
    },
    {
      id: "06",
      label: "June",
      value: "06",
    },
    {
      id: "07",
      label: "July",
      value: "07",
    },
    {
      id: "08",
      label: "August",
      value: "08",
    },
    {
      id: "09",
      label: "September",
      value: "09",
    },
    {
      id: "10",
      label: "October",
      value: "10",
    },
    {
      id: "11",
      label: "November",
      value: "11",
    },
    {
      id: "12",
      label: "December",
      value: "12",
    },
  ]);

  return (
    <Select
      value={optionData.find((opt) => opt.value === selectedMonth)}
      className={`select`}
      options={optionData}
      placeholder="Select Month"
      onChange={(selected) => monthSelectHandler(selected.value)}
      menuPortalTarget={document.body}
      styles={{
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
      }}
    />
  );
};

MonthOption.propTypes = {
  selectedMonth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  monthSelectHandler: PropTypes.func,
};

export default MonthOption;
